<template>
    <div data-head-meta />
</template>

<script setup lang="ts">
import { type ReactiveHead, useHead } from '@unhead/vue'
import { computed } from 'vue'

const props = withDefaults(
    defineProps<{
        title?: string
        description?: string
        image?: string
    }>(),
    {
        title: 'Best Web Games',
        description: 'Browse free online games.',
        image: '',
    },
)

const pageHead = computed<ReactiveHead>(() => {
    const meta: ReactiveHead['meta'] = [
        { name: 'description', content: props.description },
        { name: 'robots', content: 'noindex, follow' },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'Best Web Games' },
        { property: 'og:title', content: props.title },
        { property: 'og:description', content: props.description },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: props.title },
        { name: 'twitter:description', content: props.description },
        { name: 'apple-mobile-web-app-title', content: 'Best Web Games', key: 'apple-mobile-web-app-title' },
    ]

    if (props.image) {
        meta.push({ property: 'og:image', content: props.image }, { name: 'twitter:image', content: props.image })
    }

    return {
        title: props.title,
        meta,
    }
})

useHead(pageHead)
</script>
